import DOMPurify from "dompurify";
import {FunctionComponent, useEffect, useState} from "react";

export type SanitazeOption = {
    ALLOWED_TAGS: string[], ALLOWED_ATTR: string[]
}

type Props = {
     html: string
     options?: SanitazeOption
}
const SanitizeHTML: FunctionComponent<Props> = (props) => {

    const defaultOptions: SanitazeOption = {
        ALLOWED_TAGS: [ 'b', 'i', 'em', 'strong', 'a' ],
        ALLOWED_ATTR: ['href']
    };
    const [loading, setLoading] = useState<boolean>(true)
    useEffect(() => {
        setLoading(false)
    }, []);

    const sanitize = (dirty: string, options?: SanitazeOption) => {
        const finalOptions = options !== undefined ? {...defaultOptions, ...options} : defaultOptions
        return {
            __html: DOMPurify.sanitize(
                dirty,
                finalOptions
            )
        }
    }
    // if (DOMPurify.isSupported) {
    //     returnedComponent = <div dangerouslySetInnerHTML={sanitize(props.html, props.options)} />
    // }
    return loading ? <></> : <div dangerouslySetInnerHTML={sanitize(props.html, props.options)}/>
}

export default SanitizeHTML